
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import { EDTextEdit } from '../../../../BaseComponents/TextEdit/EDTextEdit';
import { makeStyles } from 'tss-react/mui';

interface IProps {
  searchValue?: string;
  setSearchValue?: (value: string) => void;
}

const useStyles = makeStyles()({
  searchText: {
    background: 'inherit',
    padding: '8px 8px 8px 13px',
    'label + &': {
      margin: 0,
    },
  },
  searchInput: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 0px',
    overflowY: 'auto',
  },
} as const);

/**
 * En listwrapper för CheckboxSelectListItem komponenter. Lägger ett sökfält ovanför för att hantera sökning i listan.
 */
const CheckboxSelectList: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes } = useStyles();
  return (
    <>
      {props.searchValue !== undefined && props.setSearchValue && (
        <EDTextEdit
          placeholder="Sök"
          hideLabel
          allMargins="none"
          value={props.searchValue}
          startAdornment={
            <EDIcon
              iconType="search"
              marginRight={1}
              marginLeft={1}
              color="inherit"
            />
          }
          onChange={props.setSearchValue}
          simpleLine
          fullWidth
        />
      )}
      <div className={classes.container}>{props.children}</div>
    </>
  );
};

export default CheckboxSelectList;
